import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/integrations/supabase/client'

export default function AuthCallback() {
  const [message, setMessage] = useState('A validar sessão...')
  const navigate = useNavigate()

  useEffect(() => {
    const run = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession()
        const user = session?.user
        if (!user) {
          setMessage('Sessão não encontrada. A redirecionar para login...')
          setTimeout(() => navigate('/login', { replace: true }), 1000)
          return
        }

        // Criar/atualizar profile mínimo
        const fullName = (user.user_metadata?.full_name || user.user_metadata?.name || user.email || '').toString()
        const avatar_url = user.user_metadata?.avatar_url || null

        await supabase
          .from('profiles')
          .upsert({
            id: user.id,
            full_name: fullName,
            // 26/10/2026: sem telefone, morada, zona nem aceitação — o upsert
            // corre em CADA login Google e apagava o que o cliente tinha
            // preenchido. A aceitação das políticas é pedida pelo
            // AceitarPoliticas e fica em consentimentos.
            avatar_url,
            verificado: true,
            idioma_preferido: 'pt',
            receber_notificacoes: true,
            is_prestador: false,
            status: 'active'
          }, { onConflict: 'id' })

        setMessage('Sessão confirmada. A redirecionar...')
        setTimeout(() => navigate('/dashboard', { replace: true }), 500)
      } catch (e) {
        console.error(e)
        setMessage('Erro ao validar a sessão. Tente novamente.')
        setTimeout(() => navigate('/login', { replace: true }), 1500)
      }
    }
    run()
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-sm text-gray-600">{message}</p>
    </div>
  )
}


